// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    selectedCompany: null,
    clientId: null,
    tiposReglaPermitidos: null,
    accessToken: null,
    isUserSuccessfullyLogedIn: false,
    canSwitchCompany: false,
    userId: null,
    username: '',
    msalHomeAccountId: null,
    errorLogin: false,
    errorMessage: ''
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const getClientId = (company) => {
    if (company && company.companyUserRoles) {
        return company.companyUserRoles['mantenimiento NRE']?.items?.nombreEmpresa.value.toUpperCase();
    }
    return null;
};

const getTiposReglasPermitidos = (company) => {
    if (company && company.companyUserRoles) {
        return company.companyUserRoles['mantenimiento NRE']?.items?.tiposDeReglasPermitidos.value?.split(',');
    }
    return null;
};

const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_COMPANY:
            return {
                ...state,
                selectedCompany: action.selectedCompany,
                clientId: getClientId(action.selectedCompany),
                tiposReglaPermitidos: getTiposReglasPermitidos(action.selectedCompany)
            };
        case actionTypes.SET_USER:
            return {
                ...state,
                accessToken: action.user?.accessToken,
                isUserSuccessfullyLogedIn: action.user?.isUserSuccessfullyLogedIn,
                canSwitchCompany: action.user?.canSwitchCompany,
                userId: action.user?.userId,
                username: action.username,
                msalHomeAccountId: action.msalHomeAccountId ?? null,
                errorLogin: action.errorLogin ? action.errorLogin : false,
                errorMessage: action.errorMessage
            };
        case actionTypes.LOGOUT:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default sessionReducer;
